import { isEmpty } from 'lodash-es';
import {
  Component,
  ViewEncapsulation,
  Input,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
  AfterContentChecked,
  Output,
  EventEmitter
} from '@angular/core';
import { isNullOrUndefined } from '@app/util/util';

import { SearchType } from '@search-bar/entities/search-type';
import { InputTextSize } from '@design-system/components/molecules/input-text/entities/input-text.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

@Component({
  selector: 'app-search-bar-input',
  templateUrl: './search-bar-input.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SearchBarInputComponent implements AfterContentChecked {

  @Input() searchType: SearchType;
  @Input() isPassengerField: boolean;
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() icon: Icon;
  @Input() autofocus: boolean = false;
  @Input() disabled: boolean = false;
  @Input() value: string = '';
  @Input() swapPlaceholder: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() showError: boolean;
  @Input() searchFligths: boolean;
  @Input() isMobile: boolean;
  @Input() id: string = '';

  @Output() isFocus: EventEmitter<void> = new EventEmitter<void>();
  @Output() inputChanged: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('placeInput', { static: true }) public input: ElementRef;

  public labelInput: string = '';

  constructor() { }

  ngAfterContentChecked(): void {
    if (this.autofocus && this.input) this.input.nativeElement.focus();
    this.swapPlaceholderLabel();
  }

  get inputSize(): InputTextSize {
    return !this.isMobile && (this.isResultsPage || this.isHotelDetail) ? InputTextSize.MD : InputTextSize.RG;
  }

  get filled(): boolean {
    return !this.isMobile && !this.isResultsPage && !this.isHotelDetail;
  }

  get staticFilled(): boolean {
    return !this.isMobile && (this.isResultsPage || this.isHotelDetail);
  }

  get isHomeHotels(): boolean {
    return this.searchType === SearchType.HOME_HOTELS;
  }

  get isHomeFlights(): boolean {
    return this.searchType === SearchType.HOME_FLIGHT;
  }

  get isHomeBuses(): boolean {
    return this.searchType === SearchType.HOME_BUSES;
  }

  get isHomePackages(): boolean {
    return this.searchType === SearchType.PACKAGES_HOME;
  }

  get isHome(): boolean {
    return this.isHomeHotels || this.isHomeFlights || this.isHomeBuses || this.isHomePackages;
  }

  get isHotelDetail(): boolean {
    return this.searchType === SearchType.HOTELS_DETAIL;
  }

  get isError(): boolean {
    return this.showError && !this.disabled;
  }

  get isResultsPage(): boolean {
    if (!this.isMobile) {
      return this.searchType === SearchType.HOTELS_RESULTS ||
      this.isFlightResults || this.searchType === SearchType.BUSES_RESULTS ||
      this.searchType === SearchType.PACKAGES_RESULT;
    }
  }

  get isFlightResults(): boolean {
    return this.searchType === SearchType.FLIGHT_RESULTS;
  }

  get valueExist(): boolean {
    return !isEmpty(this.value) && !isNullOrUndefined(this.value) && (!this.disabled || this.readOnly);
  }

  public onChangeInput(event: string): void {
    this.inputChanged.emit(event);
  }

  public swapPlaceholderLabel(): void {
    this.labelInput = this.value !== null && this.value !== '' && this.swapPlaceholder ? this.placeholder : this.label;
  }

  public isFocusEmit(): void {
    if (!this.disabled) this.isFocus.emit();
  }

}
